@import 'styles/mixins';
@import 'styles/variables';

.container {
  @include z-index(overlay);
  position: absolute;
}

.viewContainer {
  background: $white;
  border-radius: 8px;
  @include shadow-3;
}

.emojiRow {
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;

  &:first-of-type {
    border-radius: 8px 8px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 8px 8px;
  }
}

.emojiRow__selected {
  @extend .emojiRow;
  background: $gray-5;
}

.emojiContainer {
  font-size: 24px;
  color: black;
  margin-right: 6px;
}
